import { axiosInstance } from './axiosConfig';

export function getHistoryListBySrId({ srId, historyCutoffDate }) {
  const url = `sr/${srId}/${historyCutoffDate}/history`;
  return axiosInstance.get(url).then((response) => response.data);
}
